import { type CommunityMember, createCommunityMember } from 'models';
import { useInfiniteQuery } from 'query';
import type { ApiClientResponseError, DefaultResponseErrorDataObject } from 'common/services';
import type { CommunityMemberDataObject } from 'models/service';
import { getMembers } from '../services/get-members';
import { getCommunityMembersKey } from './keys';

type P = {
  communityId: string;
  pageSize: number;
};

export const useMembersQuery = ({ communityId, pageSize }: P) =>
  useInfiniteQuery<CommunityMember[], string | undefined, ApiClientResponseError<DefaultResponseErrorDataObject>>({
    async queryFn({ pageParam: pageParameter }) {
      const { data: members } = await getMembers(communityId, {
        cursor: pageParameter,
        limit: pageSize,
      });

      return members.map((member: CommunityMemberDataObject) => createCommunityMember(member));
    },
    initialPageParam: undefined,
    getNextPageParam: (lastPage) => (lastPage.length < pageSize ? undefined : lastPage.at(-1)?.id),
    queryKey: getCommunityMembersKey({ communityId, pageSize }),
    throwOnError: true,
  });
